import { render, staticRenderFns } from "./localAddress.vue?vue&type=template&id=3a44e5b4&scoped=true&"
import script from "./localAddress.vue?vue&type=script&lang=js&"
export * from "./localAddress.vue?vue&type=script&lang=js&"
import style0 from "./localAddress.vue?vue&type=style&index=0&id=3a44e5b4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a44e5b4",
  null
  
)

export default component.exports